import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { t } from '../../translations/getTranslation';
import CardInfo from '../../components/cards/CardInfo';
import MainLayout, { LayoutHeading } from '../../components/MainLayout';
import { Paragraph } from '../../components/Styled/typography';
import useAccountSummary from '../../hooks/useAccountSummary';
import { ReplacementCardOnlineChatButton } from '../../components/Button';
import { useEffect } from 'react';
import useConfig from '../../context/config.context';
const CantVerify = () => {
    const { isSuccess, isSemu, currentReason } = useAccountSummary();
    const { triggerAnalyticsEvent } = useConfig();
    useEffect(() => {
        if (!isSuccess) {
            return;
        }
        triggerAnalyticsEvent({
            messageType: isSemu ? 'semu' : 'nonsemu',
            pageFunction: 'replace your card',
            pageSubFunction: (currentReason === null || currentReason === void 0 ? void 0 : currentReason.value)
                ? currentReason.value.replace('-', ' ')
                : '',
            pageKind: 'account services',
            message: "we're having trouble verifying your identity",
            pageName: 'authentication failed'
        });
    }, [triggerAnalyticsEvent, isSuccess, isSemu, currentReason === null || currentReason === void 0 ? void 0 : currentReason.value]);
    return (_jsxs("div", Object.assign({ "data-cy": "cant-verify-view" }, { children: [_jsx(CardInfo, {}), _jsxs(MainLayout, Object.assign({ withImage: true }, { children: [_jsx(LayoutHeading, { title: t('cantVerify.havingTroubleVerify'), modalImageProps: {
                            imageName: 'WARNING'
                        } }), _jsxs(Paragraph, { children: [t('cantVerify.pleaseReachOut'), _jsx(ReplacementCardOnlineChatButton, {}), t('cantVerify.forAssistance')] })] }))] })));
};
export default CantVerify;
//# sourceMappingURL=index.js.map